import moment from "moment";
import React from "react";
import { withRouter } from "react-router-dom";

import LeftInfoModal from "../../../../../components/left-info-modal";
import MainButton from "../../../../../components/main-button";
import PersonalInformation, {
  PersonalData,
} from "../travel-forms/personal-information/personal-information";
import TravelAddressFormItem, { AddressData } from "../travel-forms/address-item/address-form-item";
import TravelContactFormItem, { ContactData } from "../travel-forms/contact-item/contact-form-item";
import { TravelInsuredDataContainer } from "./travel-insured-data-style";
import { images } from "../../../../../assets";

import { withCoverages } from "../../../../../context/mixin/with-coverages";
import { withGeneral } from "../../../../../context/mixin/with-general";
import { withPolicy } from "../../../../../context/mixin/with-policy";
import { PRODUCT_TYPE } from "../../../../../constants/policyType";

import TravelServices from "../../../../../services/TravelServices";
import { TravelHireMenuHelper } from "../../../../../components/travel-hire-menu";
import { getTravelRiskDataRequest } from "../helpers";
import { deepGet } from "../../../../../utils/utility";
import { TravelInsuredProps, TravelInsuredState, Taker, TravelInsured } from "./travel-insured-types";

class TravelInsuredDataLayout extends React.Component<TravelInsuredProps, TravelInsuredState> {
  constructor(props: TravelInsuredProps) {
    super(props);

    let insureds: TravelInsured[] = [];
    props.data.insureds
      ? (insureds = props.data.insureds.map((insured) => {
          const newInsured = insured.sameAsTaker
            ? this.handleGetTakerPersonalData(insured, this.props.data.taker)
            : insured;

          if (
            insured.coverages &&
            insured.coverages.length > 0 &&
            (insured.name === undefined || insured.name.length === 0)
          ) {
            return (insured = { ...newInsured, isDataValid: false });
          } else {
            return newInsured;
          }
        }))
      : (insureds = []);

    this.state = {
      validateContact: {
        validateRequest: false,
        isValidated: true,
      },
      validateAddress: {
        validateRequest: false,
        isValidated: false,
      },
      validatePerson: {
        validateRequest: false,
        isValidated: true,
      },
      cleanForm: false,
      personalData: {
        name: "",
        birthDate: moment().format("DD/MM/YYYY"),
        docNumber: "",
        gender: "",
        civilStatus: "",
        docType: "",
        lastname1: "",
        nationality: "",
        nationalityLabel: "",
        profession: { value: "", code: "", other: "" },
        lastname2: "",
        relationship: "",
        sameAsTaker: false,
        passportDate: "",
        physicalPerson: true,
        hasAnotherInsurance: false,
        numPoliza: "",
      },
      contactData: {
        comunicationChannel: "",
        comunicationLanguage: "",
        email: "",
        mobilePhone: "",
        paperless: "",
        contactHour: "",
        landlinePhone: "",
        sameAsTaker: false,
      },
      addressData: {
        address: { value: "", code: "", label: "" },
        wayType: "",
        number: "",
        postalCode: "",
        province: { value: "", code: "", label: "" },
        town: { value: "", code: "", label: "" },
        door: "",
        floor: "",
        portal: "",
        stairs: "",
        sameAsTaker: false,
        normalizaDireciones: "S",
      },
      insuredList: insureds,
      previousModalShow: false,
      nextModalShow: false,
      forceNext: false,
      usePersonalData: false,
      useAddressData: false,
      useContactData: false,
      indexInsured: this.props.match.params.index ? Number(this.props.match.params.index) : -1,
      anyChange: false,
      isPersonalCheckChanging: false,
      errorModalShow: false,
      errorModalText: "",
    };
  }

  componentDidMount = () => {
    setTimeout(function () {
      window.scrollTo(0, 0);
    }, 100);

    const { match, history, data, onGotoDetail } = this.props;
    const index = deepGet(match, "params.index", undefined);
    if (index && onGotoDetail !== Number(index)) {
      this.setState({ indexInsured: Number(index) });
      this.props.goToInsured(Number(index));
    }

    const locationSearch = deepGet(history, "location.search", "") || "";
    if (locationSearch.indexOf("new=true") > 0) {
      this.setState({ indexInsured: -1, cleanForm: true });
      return;
    }

    if (index) {
      const { insuredList } = this.state;
      const useAddressData = deepGet(insuredList, `${index}.address.sameAsTaker`, false) || false;
      const useContactData = insuredList.length > 0 && insuredList[index].sameAsTaker;
      const usePersonalData = insuredList.length > 0 && insuredList[index].sameAsTaker;

      this.setState({
        indexInsured: index,
        useAddressData,
        usePersonalData,
        useContactData,
      });
    }

    if (data.insureds !== undefined && data.insureds.length !== 0) {
      this.setState({ indexInsured: 0 });
    }

    this.handleInsuredAsTakerChange();
    this.props.haveInsuredSaved(false);
  };

  componentWillReceiveProps(nextProps: TravelInsuredProps) {
    if (nextProps.saveInsured) {
      this.saveInsured();
    }

    if (nextProps.removeInsured) {
      this.removeInsured();
    }

    if (nextProps.newInsured || this.props.location.search.indexOf("new=true") > 0) {
      this.setState(
        {
          cleanForm: true,
          indexInsured: -1,
          usePersonalData: false,
          useAddressData: false,
          useContactData: false,
        },
        () => this.setState({ cleanForm: false })
      );
      this.props.history.replace(
        `/contratacion/nueva/travel/${this.props.match.params.product}/asegurados`
      );
    } else if (
      nextProps.onGotoDetail !== undefined &&
      nextProps.onGotoDetail !== this.state.indexInsured
    ) {
      const { insuredList } = this.state;
      const insuredData = insuredList[nextProps.onGotoDetail];

      this.setState({
        indexInsured: nextProps.onGotoDetail,
        usePersonalData: nextProps.onGotoDetail === 0 ? insuredData.sameAsTaker : false,
        useAddressData: insuredData && insuredData.address && insuredData.address.sameAsTaker || false,
        useContactData: insuredData && insuredData.sameAsTaker,
      });
    }
  }

  componentDidUpdate() {
    const { history } = this.props;
    const { validateContact, validateAddress, validatePerson, cleanForm } = this.state;
    if (validateAddress.validateRequest) {
      validateAddress.validateRequest = false;
      validateContact.validateRequest = false;
      validatePerson.validateRequest = false;

      if (
        validateContact.isValidated &&
        validateAddress.isValidated &&
        validateAddress.isValidated
      ) {
        history.push(
          `/contratacion/nueva/travel/${this.props.match.params.product}/proteccion-datos`
        );
      }

      if (cleanForm) {
        this.setState({ cleanForm: false });
      }
    }
  }

  toValidate = async () => {
    let { validateContact, validateAddress, validatePerson } = this.state;
    validateContact.validateRequest = true;
    validateAddress.validateRequest = true;
    validatePerson.validateRequest = true;

    this.setState({ validateContact, validateAddress, validatePerson });
  };

  async saveInsured() {
    await this.validateAndSave();
  }

  async validateAndSave() {
    const { validateAddress, validateContact, validatePerson } = this.state;
    await this.toValidate();

    if (validateAddress.isValidated && validateContact.isValidated && validatePerson.isValidated) {
      const { personalData, contactData, addressData } = this.state;
      let { indexInsured } = this.state;
      let insured = {
        ...personalData,
        ...contactData,
        address: addressData,
        insured: true,
        coverages: [],
        isDataValid: true,
      };

      this.props.policy.setTravelData(insured, indexInsured > -1 ? indexInsured : undefined);
      this.props.saveHiring(true);

      const newInsuredList = this.state.insuredList;

      if (indexInsured === -1) {
        newInsuredList.push(insured);
        indexInsured = newInsuredList.length - 1;
        this.props.goToInsured(indexInsured);
      } else {
        const coverages = deepGet(newInsuredList, `${indexInsured}.coverages`, []) || [];
        newInsuredList[indexInsured] = { ...insured, coverages };
      }
      this.setState(
        {
          anyChange: false,
          indexInsured,
          insuredList: newInsuredList,
        },
        () => this.props.haveInsuredSaved(false)
      );
    }
  }

  removeInsured() {
    const { insureds } = this.props.data;
    const { onGotoDetail, indexRemove, goToInsured } = this.props;

    if (onGotoDetail && onGotoDetail > indexRemove) {
      const index = onGotoDetail - 1;
      this.props.history.replace(
        `/contratacion/nueva/travel/${this.props.match.params.product}/asegurados/${index}`
      );
      goToInsured(index);
    }
    const newInsuredList = JSON.parse(JSON.stringify(insureds));
    this.setState({ insuredList: newInsuredList });
  }

  onNextClick = async (forceNext: boolean = false) => {
    const { policy, setLoading, data } = this.props;
    const nextStep = data.taker.physicalPerson ? 1 : 2;

    if (forceNext) {
      this.props.saveHiring(false, false, true);
      this.props.history.push(
        TravelHireMenuHelper.getStepNavigationPath(
          TravelHireMenuHelper.getStepFromNavigationRoute(
            this.props.match.url,
            policy.product.products_internalName
          ) + nextStep,
          this.props.data.insureds.length,
          policy.product.products_internalName
        )
      );
    }

    if (this.state.anyChange) {
      this.setState({ nextModalShow: true });
      return;
    }

    const internalName = deepGet(policy, "product.products_internalName", "") || "";
    const requestData = getTravelRiskDataRequest({
      data,
      internalName,
    });

    const riskData = await TravelServices.getRiskData({
      setLoading,
      loader: true,
      request: requestData,
      internalName,
    });

    if (riskData.ok) {
      const isAllYearProduct = policy.product.products_internalName === PRODUCT_TYPE.TRAVEL_ALL_YEAR;
      const newData = {
        ...data,
        status: deepGet(riskData.data, "body.RESPUESTA.ESTADO", ""),
        idcotiza: deepGet(riskData.data, "body.RESPUESTA.COTIZACION", ""),
        ...(isAllYearProduct ? { taker: {
          ...data.taker,
          policy: {
            ...data.taker.policy,
            departureDate: moment().format("DD/MM/YYYY"),
            returnDate: moment().add(1, "years").subtract(1, "days").format("DD/MM/YYYY")
          }
        }} : {}),
      };

      await this.props.policy.setTravelData(newData);
      await this.props.saveHiring();
      
      this.props.history.push(
        TravelHireMenuHelper.getStepNavigationPath(
          TravelHireMenuHelper.getStepFromNavigationRoute(
            this.props.match.url,
            policy.product.products_internalName
          ) + nextStep,
          this.props.data.insureds.length,
          policy.product.products_internalName
        )
      );
    } else {
      this.setState({
        errorModalShow: true,
        errorModalText: riskData.message,
      });
    }
  };

  onPreviousClick(forcePrevious: boolean = false) {
    const { policy } = this.props;

    if (forcePrevious || !this.state.anyChange)
      this.props.history.push(
        TravelHireMenuHelper.getStepNavigationPath(
          TravelHireMenuHelper.getStepFromNavigationRoute(
            this.props.match.url,
            policy.product.products_internalName
          ) - 1,
          this.props.data.insureds.length,
          policy.product.products_internalName
        )
      );
    else this.setState({ previousModalShow: true });
  }

  onComponentAnyChange() {
    const { anyChange } = this.state;
    if (anyChange === false) {
      this.setState({ anyChange: true });
      this.props.haveInsuredSaved(anyChange);
    }
  }

  receiveInsuredAddress(insuredAddress: AddressData) {
    let { addressData } = this.state;
    addressData = insuredAddress;
    this.setState({ addressData });
  }

  receiveInsuredContact(insuredContact: ContactData) {
    let { contactData } = this.state;
    contactData = insuredContact;
    this.setState({ contactData });
  }

  receiveInsuredPerson(insuredPerson: PersonalData) {
    let { personalData } = this.state;
    personalData = insuredPerson;
    this.setState({ personalData });
  }

  handleUseTakerData(useData: boolean, type: string) {
    if (type === "personal") {
      this.setState(
        {
          usePersonalData: useData,
          useAddressData: useData,
          useContactData: useData,
          isPersonalCheckChanging: true,
        },
        () => this.setState({ isPersonalCheckChanging: false })
      );
    } else {
      if (!this.state.usePersonalData) {
        this.setState({ useAddressData: useData });
      } else {
        this.setState({ useAddressData: useData });
      }
    }
  }

  checkDataIsValid(): boolean {
    const { insuredList } = this.state;
    if (insuredList && insuredList.length > 0) {
      // filtra la lista de asegurados a los que se les ha completado sus datos (isDataValid)
      const validInsuredList = insuredList.filter((insured) => insured.isDataValid);
      return validInsuredList.length === insuredList.length;
    }
    return false;
  }

  getInsuredsAdress = (insureds: TravelInsured[] | undefined): AddressData[] | undefined =>
    insureds ? insureds.map((obj) => obj.address) : undefined;

  handleInsuredAsTakerChange() {
    let { insuredList } = this.state;
    let { policy, saveHiring, data, isReadOnly } = this.props;

    let haveChanges: boolean = false;
    insuredList.forEach((insured, indexInsured: number) => {
      if (insured.sameAsTaker) {
        //Validación por si el tomador cambió a persona jurídica
        if (!data.taker.physicalPerson) {
          insured.sameAsTaker = false;
        } else {
          insured = this.handleGetTakerPersonalData(insured, data.taker);
        }

        policy.setTravelData(insured, indexInsured > -1 ? indexInsured : undefined);
        haveChanges = true;
      }

      if (insured && insured.address && insured.address.sameAsTaker) {
        insured = this.handleGetTakerAddressData(insured, data.taker);

        policy.setTravelData(insured, indexInsured > -1 ? indexInsured : undefined);
        haveChanges = true;
      }
    });
    !isReadOnly && haveChanges && saveHiring(true);
  }

  handleGetTakerPersonalData(insured: TravelInsured, taker: Taker): TravelInsured {
    insured.name = taker.name;
    insured.lastname1 = taker.lastname1 ? taker.lastname1 : "";
    insured.lastname2 = taker.lastname2;
    insured.birthDate = moment(taker.birthDate, "DD/MM/YYYY").format("DD/MM/YYYY");
    insured.docType = taker.docType;
    insured.docNumber = taker.docNumber;
    insured.passportDate = taker.passportDate || "";
    insured.gender = taker.gender ? taker.gender : "";
    insured.nationality = taker.nationality;
    insured.nationalityLabel = taker.nationalityLabel ? taker.nationalityLabel : "";
    insured.physicalPerson = taker.physicalPerson;
    return insured;
  }

  handleGetTakerAddressData(insured: TravelInsured, taker: Taker): TravelInsured {
    insured.address.address = taker.address.address;
    insured.address.wayType = taker.address.wayType;
    insured.address.number = taker.address.number;
    insured.address.portal = taker.address.portal;
    insured.address.stairs = taker.address.stairs;
    insured.address.floor = taker.address.floor;
    insured.address.door = taker.address.door;
    insured.address.postalCode = taker.address.postalCode;
    insured.address.town = taker.address.town;
    insured.address.province = taker.address.province;
    insured.address.normalizaDireciones = taker.address.normalizaDireciones;

    return insured;
  }

  render() {
    const {
      validateContact,
      validateAddress,
      validatePerson,
      cleanForm,
      useAddressData,
      useContactData,
      usePersonalData,
      indexInsured,
      isPersonalCheckChanging,
    } = this.state;
    const { isReadOnly, policy } = this.props;
    const productInternalName = policy.product.products_internalName;
    const currentTravelStep = TravelHireMenuHelper.getStepFromNavigationRoute(
      this.props.history.location.pathname,
      productInternalName
    );

    return (
      <TravelInsuredDataContainer>
        <div className="colSin-100">
          <div className="data-flow-status">
            <div className="data-flow-status-title">
              <h2>DATOS DEL ASEGURADO</h2>
            </div>
          </div>

          <PersonalInformation
            validate={validatePerson}
            onValidated={(insured: PersonalData) => this.receiveInsuredPerson(insured)}
            onCheckTakerData={(useData: boolean) => this.handleUseTakerData(useData, "personal")}
            onCleanForm={cleanForm}
            insured={true}
            setLoading={this.props.setLoading}
            taker={this.props.data.taker}
            insureds={this.props.data.insureds}
            insuredIndex={indexInsured}
            isReadOnly={isReadOnly}
            currentTravelStep={currentTravelStep}
            onAnyChange={() => {
              this.onComponentAnyChange();
            }}
          />

          <TravelAddressFormItem
            validate={validateAddress}
            onValidated={(insured: AddressData) => this.receiveInsuredAddress(insured)}
            onCheckTakerData={(useData: boolean) => this.handleUseTakerData(useData, "address")}
            onCleanForm={cleanForm}
            insured={true}
            setLoading={this.props.setLoading}
            useTakerData={useAddressData}
            usePersonalTakerData={usePersonalData}
            taker={this.props.data.taker.address}
            insureds={this.getInsuredsAdress(this.props.data.insureds)}
            insuredIndex={indexInsured}
            isReadOnly={isReadOnly}
            physicalPerson={true}
            isPersonalCheckChanging={isPersonalCheckChanging}
            onAnyChange={() => {
              this.onComponentAnyChange();
            }}
          />

          <TravelContactFormItem
            validate={validateContact}
            onValidated={(insured: ContactData) => this.receiveInsuredContact(insured)}
            useTakerData={useContactData}
            onCleanForm={cleanForm}
            onEditInsured={indexInsured}
            taker={this.props.data.taker}
            insureds={this.props.data.insureds}
            insuredIndex={indexInsured}
            insured={true}
            isReadOnly={isReadOnly}
            onAnyChange={() => {
              this.onComponentAnyChange();
            }}
            isPersonalCheckChanging={isPersonalCheckChanging}
          />

          <div className="colSin-100 topMargin20 bottomMargin20">
            <div className="personal-data-buttons">
              <div className="personal-data-buttons__item">
                <MainButton
                  withTab={true}
                  icon={true}
                  type={"white"}
                  iconImg={images.IconArrowLeftBlue}
                  text="Atrás"
                  onClick={() => this.onPreviousClick()}
                />
              </div>
              <div className="personal-data-buttons__item">
                <MainButton
                  disabled={!this.checkDataIsValid()}
                  withTab={true}
                  text="Siguiente"
                  onClick={this.onNextClick}
                />
              </div>
            </div>
          </div>

          <LeftInfoModal
            img={images.IconWarningYellow}
            mainTitle="Error"
            mainText={this.state.errorModalText}
            buttonText="Aceptar"
            closeButtonText="Cancelar"
            close={() => this.setState({ errorModalShow: false })}
            active={this.state.errorModalShow}
            onClickAccept={() => this.setState({ errorModalShow: false })}
            className="error"
            noSecondaryButton
          />
          <LeftInfoModal
            img={images.IconWarningYellow}
            mainTitle={"¿Seguro que desea continuar sin guardar?"}
            mainText={"Perderá todos los cambios introducidos."}
            buttonText="Continuar"
            closeButtonText="Cancelar"
            close={() => this.setState({ previousModalShow: false })}
            active={this.state.previousModalShow}
            onClickAccept={() =>
              this.setState({ previousModalShow: false }, () => this.onPreviousClick(true))
            }
            className="error"
          />

          <LeftInfoModal
            img={images.IconWarningYellow}
            mainTitle={"¿Seguro que desea continuar sin guardar?"}
            mainText={"Perderá todos los cambios introducidos."}
            buttonText="Continuar"
            closeButtonText="Cancelar"
            close={() => this.setState({ nextModalShow: false })}
            active={this.state.nextModalShow}
            onClickAccept={() =>
              this.setState({ nextModalShow: false }, () => this.onNextClick(true))
            }
            className="error"
          />
        </div>
      </TravelInsuredDataContainer>
    );
  }
}

export default withCoverages(withPolicy(withGeneral(withRouter(TravelInsuredDataLayout))));
